/** Total steps: dashboard (0–3), library (4), reviews (5), templates (6). */
export const WALKTHROUGH_TOTAL_STEPS = 7;
